<div class="row">
    <div class="col-12">
        <form [formGroup]="formGroup">
            <mat-form-field appearance="outline" class="color-picker-field w-100">
                <mat-label>{{ label }}</mat-label>

                <!-- Interactive Color Swatch Prefix -->
                <div matPrefix class="swatch-container mt-2" [style.backgroundColor]="formGroup.get(key).value">
                    <input #nativeColorInput type="color" [ngModelOptions]="{standalone: true}" class="native-color-picker"
                        [(ngModel)]="selectedColor" (ngModelChange)="onNativeColorInput($event)"
                        aria-label="Color preview picker" />
                </div>

                <!-- Hex Text Input -->
                <input matInput type="text" [formControlName]="key" placeholder="#1976D2" maxlength="7" />


                <!-- Validation Error Messages -->
                <mat-error *ngIf="formGroup.get(key).hasError('pattern')">
                    Enter a valid Hex color (e.g. #1976D2)
                </mat-error>
                <mat-error *ngIf="formGroup.get(key).hasError('required')">
                    Color is required
                </mat-error>
            </mat-form-field>
        </form>
    </div>
</div>